import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { posthog } from "posthog-js";

import Logo from "@/assets/logo_name.svg";

import AddOpportunityForm from "@/components/forms/company/opportunity";

import { useDraftProfileStore } from "@/stores/draft-profile";
import { useClaimUserPrescreenDraft } from "@/mutations/user/claim-user-prescreen-draft";

const CompanyPrescreenJobs = () => {
  const { claimUserPrescreenDraft, isClaimingUserPrescreenDraft } =
    useClaimUserPrescreenDraft();

  const { draftProfileSessionId, setDraftProfileSessionId } =
    useDraftProfileStore();

  const navigate = useNavigate();

  useEffect(() => {
    if (draftProfileSessionId && !isClaimingUserPrescreenDraft) {
      claimUserPrescreenDraft(draftProfileSessionId);
      setDraftProfileSessionId(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftProfileSessionId]);

  if (Boolean(draftProfileSessionId) || isClaimingUserPrescreenDraft) {
    return;
  }

  return (
    <>
      <div className="p-8 w-full flex flex-col gap-7">
        <div className="flex flex-col gap-4">
          <div className="py-4">
            <img
              className="h-9 object-contain self-start"
              src={Logo}
              alt="Venturous logo"
            />
          </div>
        </div>
        <div className="max-w-4xl w-full mx-auto flex flex-col gap-2 items-center">
          <AddOpportunityForm
            includeSteps
            startingStep={2}
            stepTotal={3}
            onSkip={() => navigate("/landing")}
            onSuccess={() => {
              posthog.capture("company_add_job_optional");
              navigate("/landing");
            }}
          />
        </div>
      </div>
    </>
  );
};

export default CompanyPrescreenJobs;
